import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack } from "@mui/material";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import { WifiKeyExpiry } from "../WifiKeyExpiry";
import { SetStateAction, useState } from "react";
import { Dayjs } from "dayjs";
import { VillageWifiUserType } from "../../../enums/VillageWifiUserType";


type WifiKeyExpiryDialogProps = {

    dialogOpen: boolean;
    handleCancel: ( ) => void;
    // handleOk: ( expiry: Dayjs | undefined ) => void;
    handleOk: ( expiry: string | undefined ) => void;

    initialExpiry : Dayjs | undefined;
    wifiUserType : VillageWifiUserType;

};


export const WifiKeyExpiryDialog : React.FC< WifiKeyExpiryDialogProps > = ( props : WifiKeyExpiryDialogProps ) => {

    const { dialogOpen, handleCancel, handleOk, initialExpiry, wifiUserType } = props;


    // const [ expiry, setExpiry ] = useState< Dayjs  >( );
    const [ expiry, setExpiry ] = useState< string >( );

    
    const handleSelectWifiKeyExpiry = ( expiry : SetStateAction< string | undefined > ) => setExpiry( expiry ) ;


    // const handleSelectWifiKeyExpiry = ( expiry : SetStateAction< Dayjs | null > ) => {

    //     if( expiry ) {

    //         setExpiry( expiry as Dayjs );

    //     } else {

    //         setExpiry( undefined );

    //     }

    // };


    const handleCancelClick = () => {

        handleCancel( );
        setExpiry( undefined );

    };
    
    
    const handleOkClick = ( ) => {

        
        handleOk( expiry );
        setExpiry( undefined );

    };

    return(

        <Dialog
            sx={{ '& .MuiDialog-paper': { maxHeight: 435, width: '500px' } }}
            open={dialogOpen}>
            <DialogTitle>Enter Wi-Fi Key Expiry</DialogTitle>
            <DialogContent dividers>

                <Stack gap={0.5}>
                    
                    <WifiKeyExpiry
                        expiryOptions={ wifiUserType === VillageWifiUserType.Visitor ? [ '1','3','7','C' ] : [ '1', '7', 'N', 'C' ] } 
                        isDisabled={ false } 
                        resetWifiKeyExpiry={ 0 } 
                        selectWifiKeyExpiry={ handleSelectWifiKeyExpiry } 
                        initialWifiKeyExpiry={ initialExpiry }
                    />

                </Stack>
 
            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }} disabled={ false }>
                    Ok
                </Button>
                <Button autoFocus onClick={ handleCancelClick } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>

    );

};